module.exports = __webpack_public_path__ + "static/media/logo_villaresidence_transparent.fb9e5bbd.png";